module.exports = __webpack_public_path__ + "static/gallery-4@2x-05a7a0a0e0ed911079f43131efee45fc.jpg";